import { getIsApiPending, getPremiumCalculation, getQuoteForm } from '../../../selectors/travelSs/quote';
import { apiTransitionShareQuoteForm, shareQuoteSuccess, shareQuoteFailure } from '../../../actions/travelSs/quote';
import { getAccessToken } from '../../../selectors/travelSs/payments';
import axios from 'axios';

export const shareQuoteService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionShareQuoteForm.pending());
            try {
                const resp = await share(store.getState());
                store.dispatch(shareQuoteSuccess(resp.data));
                store.dispatch(apiTransitionShareQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionShareQuoteForm.failure());
                store.dispatch(shareQuoteFailure(e));
            }
        }
    })();
    return next(action);
};

function convertDateFormat(dateString) {
    if (dateString) {
        const [day, month, year] = dateString.split('/');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    return '-';
}

const getNumberOfChildren = (quotation) => {
    if (quotation.selectedCover.value === 'Senior') {
        return 0;
    }

    return quotation.noOfMinors.value ? parseInt(quotation.noOfMinors.value) : 0;
};

const determineComposition = (quotation) => {
    const adultTravellers = parseInt(quotation.noOfTravellers?.value) || 0;
    const minorTravellers = parseInt(quotation.noOfMinors?.value) || 0;
    const totalNoOfTravellers = adultTravellers + minorTravellers;

    if (totalNoOfTravellers > 1) {
        return 'group';
    }

    return 'single';
};

const determineAxaDestinationArea = (quotation) => {
    if (quotation.selectedCover.value === 'Schengen') {
        return 'Schengen Area';
    }

    if (quotation.selectedCover.value === 'East Africa') {
        return 'East African country';
    }

    if (quotation.selectedCover.value === 'Holiday') {
        return 'Holiday';
    }

    return 'Senior';
};

const shareQuotePayload = (state) => {
    const quotation = getQuoteForm(state);

    const premiumCalculationPayload = {
        destination_area: determineAxaDestinationArea(quotation),
        start_date: convertDateFormat(quotation.departureDate.value),
        end_date: convertDateFormat(quotation.returnDate.value),
        composition: determineComposition(quotation),
        adult: quotation.selectedCover.value !== 'Senior' ? parseInt(quotation.noOfTravellers?.value) : 0,
        children: getNumberOfChildren(quotation),
        senior: quotation.selectedCover.value === 'Senior' ? parseInt(quotation.noOfTravellers?.value) : 0,
        oldest_traveler_age: parseInt(quotation.age.value),
        countryCode: 'SS',
        getQuoteEmail: quotation.shareEmail.value,
    };

    return {
        ...premiumCalculationPayload,
    };
};

const share = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ss/share-quote';
        return await axios.post(url, shareQuotePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
